class SingleAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const titleContainer = document.createElement('div');
    const h2 = document.createElement('h2');
    const button = document.createElement('button');
    button.addEventListener('click', this.toggle);
    
    titleContainer.setAttribute('class', 'flex justify-between items-center order-1');
    h2.setAttribute('class', 'font-semibold text-[16px] xl:text-[17.5px] m-0');
    button.setAttribute('class', 'p-[5px] bg-[#3D6899] border border-[#3D6899] rounded-full text-white hover:text-[#3D6899] hover:bg-white');
    button.setAttribute('type', 'button');

    h2.innerText = this.getAttribute('title');

    button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[16px] h-[16px]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg> 
    `;

    titleContainer.appendChild(h2);
    titleContainer.appendChild(button);
    this.appendChild(titleContainer);

  }

  toggle() {
    const target = this.closest('single-accordion').querySelector('[data-id=target]');
    
    if (target.classList.contains('max-h-0')) {
      target.classList.replace('max-h-0', 'max-h-full');

      this.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[16px] h-[16px]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
      </svg>
      `;
      return;
    }

    target.classList.replace('max-h-full', 'max-h-0');
    this.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[16px] h-[16px]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      `;
  }
}

if (!customElements.get('single-accordion')) {
  customElements.define('single-accordion', SingleAccordion);
}

function toggleAccordion(index) {
  const content = document.getElementById(`content-${index}`);
  const icon = document.getElementById(`icon-${index}`);

  // SVG for Down icon
  const downSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
    </svg>
  `;

  // SVG for Up icon
  const upSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path fill-rule="evenodd" d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z" clip-rule="evenodd" />
    </svg>
  `;

  // Toggle the content's max-height for smooth opening and closing
  if (content.style.maxHeight && content.style.maxHeight !== '0px') {
    content.style.maxHeight = '0';
    icon.innerHTML = upSVG;
  } else {
    content.style.maxHeight = content.scrollHeight + 'px';
    icon.innerHTML = downSVG;
  }
}